import { render, staticRenderFns } from "./auditTrailComponent.vue?vue&type=template&id=14caa87e&scoped=true&"
import script from "./auditTrailComponent.vue?vue&type=script&lang=js&"
export * from "./auditTrailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14caa87e",
  null
  
)

export default component.exports